//获取车辆基本信息
import service from "../../request/request"
export function get_area_list(name) {
    return service({
        url: "/api/many_car_monitor/get_car_group_list_with_car_info",
        method: 'POST',
        data: {
            // row: {
            //     name: name,
            // }
        }
    })
}
//地图渲染  组全部车辆数据成功
export function get_area_all_car_info(area_id, page, size) {
    return service({
        url: "/api/many_car_monitor/get_group_all_car_info",
        method: 'POST',
        data: {
            row: {
                group_id: area_id,
                page: page,
                size: size,
            }
        }
    })
}
export function get_area_car_list(page, limit, area_id) {
    return service({
        url: "/api/many_car_monitor/get_group_car_list",
        method: 'POST',
        data: {
            row: {
                group_id: area_id,
                page: page,
                size: limit,

            }
        }
    })
}

export function focus_car(vin, focus_status) {
    return service({
        url: "/api/many_car_monitor/focus_car",
        method: 'POST',
        data: {
            row: {
                vin: vin,
                status: focus_status,
            }
        }
    })
}
export function get_all_car_status() {
    return service({
        url: "/api/many_car_monitor/get_all_car_status",
        method: 'POST',

    })
}
// table 信息
export function get_area_all_car_info_list(area_id, page, size) {
    return service({
        url: "/api/many_car_monitor/get_group_all_car_info_list",
        method: 'POST',
        data: {
            row: {
                group_id: area_id,
                page: page,
                size: size,
            }
        }
    })
}
export function get_area_one_car_info(vin) {
    return service({
        url: "/api/many_car_monitor/get_group_one_car_info",
        method: 'POST',
        data: {
            row: {
                vin: vin,
            }
        }
    })
}
export function get_one_car_history_info_list(vin, start_time, end_time, page) {
    return service({
        url: "/api/many_car_monitor/get_one_car_history_info_list",
        method: 'POST',
        data: {
            row: {
                vin: vin,
                start_time: start_time,
                end_time: end_time,
                page: page
            }
        }
    })
}
export function while_traveling(code) {
    return service({
        url: "/api/cloudwatch/while_traveling",
        method: 'POST',
        data: {
            row: {
                code: code,

            }
        }
    })
}
export function get_car_group_list(name) {
    return service({
        url: "/api/many_car_monitor/get_car_group_list",
        method: 'POST',
        data: {
            // row: {
            //     name: name,

            // }
        }
    })
}
export function update_car_group(id, name) {
    return service({
        url: "/api/many_car_monitor/update_car_group",
        method: 'POST',
        data: {
            row: {
                id: id,
                name: name,

            }
        }
    })
}

export function delete_car_group(id) {
    return service({
        url: "/api/many_car_monitor/delete_car_group",
        method: 'POST',
        data: {
            row: {
                id: id,

            }
        }
    })
}
export function add_car_group(name, parent_id) {
    return service({
        url: "/api/many_car_monitor/add_car_group",
        method: 'POST',
        data: {
            row: {
                name: name,
                parent_id: parent_id
            }
        }
    })
}
export function get_group_car_list(group_id, page, size) {
    return service({
        url: "/api/many_car_monitor/get_group_car_list",
        method: 'POST',
        data: {
            row: {
                group_id: group_id,
                page: page,
                size: size,

            }
        }
    })
}
export function get_vin_list_by_group_id(group_id, page, size) {
    return service({
        url: "/api/many_car_monitor/get_vin_list_by_group_id",
        method: 'POST',
        data: {
            row: {
                group_id: group_id,
            }
        }
    })
}

export function add_car_to_group(group_id, vin_list) {
    return service({
        url: "/api/many_car_monitor/add_car_to_group",
        method: 'POST',
        data: {
            row: {
                group_id: group_id,
                vin_list: vin_list
            }
        }
    })
}

export function delete_car_from_group(group_id, vin_list) {
    return service({
        url: "/api/many_car_monitor/delete_car_from_group",
        method: 'POST',
        data: {
            row: {
                vin_list: vin_list
            }
        }
    })
}
// export function get_one_car_history_info(vin) {
//     return service({
//         url: "/api/many_car_monitor/get_one_car_history_info",
//         method: 'POST',
//         data: {
//             row: {
//                 vin: vin
//             }
//         }
//     })
// }
export function g_one_car_real_info(vin) {
    return service({
        url: "/api/many_car_monitor/get_one_car_real_time_info",
        method: 'POST',
        data: {
            row: {
                vin: vin
            }
        }
    })
}
export function get_one_car_history_info(vin,start_time,is_first,interval) {
    return service({
        url: "/api/many_car_monitor/get_one_car_history_info",
        method: 'POST',
        data: {
            row: {
                vin: vin,
                start_time: start_time,
                is_first: is_first,
                interval:interval
            }
        }
    })
}
